<!-- 
  <myserch
    ref='table_selectContact'
    size='small'
    v-event.selectContact='mysearch=>selectContact({name: mysearch.viewobj.input_keyword})'
    v-event.checkNoneEmpty='viewobj=>'
    v-event:@checkNoneEmpty?.deleteContact='(viewobj,$rows,table_selectContact)=>{}'
    :viewobj='{
      "1": "1",
      "#1 input_name #5": "请输入名称...",
      "#2 input_keyword #5 #&": "请输入关键字...",
      "datetime #7": [ "开始日期-结束日期", "", "@input" ],

      select_state: [ "全部|过审|未过审|待审核"|selectData, "@select:selectAll", "@change" ]
      "button_search#&": [ "el-icon-search#搜索", "selectContact" ],

      button_plus#right: [ "el-icon-circle-plus#添加用户", v=>$form("addUser") ]
      button_delete#right: [ "el-icon-circle-plus#批量删除", "deleteContact" ]
      button_action#right: [ "el-icon-action#批量审核", "deleteContact", "warning:请选择你要审核的行!|auto@|#readonly|#disable" ]
    }'
  ></myserch> 
-->

<template>

  <el-row style="margin-bottom:10px;">

    <el-col :span="18" class='flex'>

      <el-input
        v-model="Data.inputText"
        placeholder="请输入衍书号、用户名、姓名查询"

        remark="👆上面是自定义的,👇下面是固定的无需修改"

        clearable
        size='small'
        style="max-width:380px;" />

      <el-button 
        v-event:click.selectContact="`selectContact.$next({name:Data.inputText})`"
        
        remark="👆上面是自定义的,👇下面是固定的无需修改"

        type="primary" 
        icon='el-icon-search' 
        size='small'
        style='margin-left:10px;' >搜索</el-button>

    </el-col>

    <el-col :span="6">

      <el-button 
        @click=" $form('addUser') "
        
        remark="👆上面是自定义的,👇下面是固定的无需修改"

        size='small'
        type="primary" 
        style="float:right" 
        icon='el-icon-circle-plus' >添加用户</el-button>
        
    </el-col>

  </el-row>

</template>

<script>
export default {
  name: 'MySearch',
  props: [ 'formobj', 'ruleobj'  ],
  data () {
    return {
      Myformobj:  null,
      Myruleobj: null,
    }
  },
  created(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/$MySearch.vue